import { render, staticRenderFns } from "./AssetDiscussions.vue?vue&type=template&id=2adf0fd4&"
import script from "./AssetDiscussions.vue?vue&type=script&lang=js&"
export * from "./AssetDiscussions.vue?vue&type=script&lang=js&"
import style0 from "./AssetDiscussions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports